import { defineStore } from 'pinia'
import { useQuasar } from 'quasar'
import { computed } from 'vue'

export const useDeviceStore = defineStore('pinia/device', () => {
  const $q = useQuasar()

  // Check if the device is desktop based on Quasar's platform and screen size
  const isDesktopScreen = computed(() => $q.screen.gt.sm)
  const isDesktop = computed(
    () => $q.platform.is.desktop && isDesktopScreen.value
  )
  const isMobileScreen = computed(() => $q.screen.lt.md)
  const isMobile = computed(() => $q.platform.is.mobile && isMobileScreen.value)
  const isNativeApp = computed(() => $q.platform.is.capacitor)
  return { isDesktopScreen, isDesktop, isMobileScreen, isMobile, isNativeApp }
})
